/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import * as yup from 'yup';
import { cloneDeep } from 'lodash';

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    return question;
  })
};

function handleSave({
  values,
  questionnaire,
  idOperation,
  SECTIONS,
  isDraft,
  mc,
  formikRef,
  refQuestionnaireSent,
  useSaveQuestionnaireAnswerRequest,
  clientsContacts,
  insurersContacts,
  insurers,
  isEndorsementWithoutPaymentPack,
  isDirectPaymentAnswer,
}) {
  buildValidation({
    values,
    questionnaire,
    SECTIONS,
    isDraft,
  }).validate(values, { abortEarly: false }).then(async () => {
    const {hasContact, message} = validationContactLength({
      clientsContacts,
      insurersContacts,
      insurers,
      isEndorsementWithoutPaymentPack,
      isDirectPaymentAnswer,
    });

    if (!hasContact) {
      mc.error(message);
      return;
    }
    handleSubmit({
      values,
      questionnaire,
      onlyQuestions: false,
      SECTIONS,
      isDraft,
      refQuestionnaireSent,
      useSaveQuestionnaireAnswerRequest,
    });

  }).catch((error) => {
    onValidationError({
      error,
      mc,
      formikRef,
      questionnaire,
      groupQuestionnaires: [],
    })
  })
}

function buildValidation({
  values,
  questionnaire,
  SECTIONS,
  isDraft,
}) {
  const validationSchema = {};

  const validationQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    questionnaire,
    onlyQuestions: true,
    SECTIONS,
  });

  for (const question of validationQuestionnaire) {
    validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
      ? yup.string().test("answer-validation", "Required field", function (value) {
        return !!question.answer;
      }) : yup.string().notRequired();
    
  }
  return yup.object().shape(validationSchema);
}



function onValidationError({
  error,
  mc,
  formikRef,
  questionnaire,
  groupQuestionnaires
}) {
  console.log('onValidationError catch initial', error)

  questionnaire = cloneDeep(questionnaire);
  groupQuestionnaires = cloneDeep(groupQuestionnaires);

  mc.error('Please complete all required fields to proceed.')
  const allQuestions = questionnaire;

  groupQuestionnaires.forEach((grpQuestionnaire) => {
    Array.isArray(grpQuestionnaire)
      ? grpQuestionnaire.map(question => allQuestions.push(question))
      : grpQuestionnaire.questions.map(question => allQuestions.push(question))
  });

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
      formikRef.current.setFieldError(question.key, null);
    }

    error.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question.key === path);
      if (!question) return;

      if (question.dsQuestion === "E-mail") {
        mc.error(`The email entered is invalid`);
        formikRef.current.setFieldError(question.key, `* Invalid email`);
      } else {
        mc.error(`The Field: ${question.dsQuestion} is required`);
        formikRef.current.setFieldError(question.key, `* Required field`);
      }

      if (!firstErrorKey) firstErrorKey = question.key;
    });

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}

function handleQuestionnaireAnswerToSave({
  values,
  questionnaire,
  onlyQuestions,
  SECTIONS,
}) {
  let questionnaireAnswers = cloneDeep(questionnaire);

  for (const [, section] of Object.entries(SECTIONS)) {
    if (section.isMultiple) {
      let multipleFields = []
      switch (section.name) {
        default:
          multipleFields = [];
          break;
      }

      multipleFields.map(group => {
        if (group?.length) {
          const rootQuestion = group.find(question => !question.idQuestionRoot);
          const childrenQuestions = group.filter(question => question.idQuestionRoot);
          rootQuestion.childrenQuestions = childrenQuestions;
          if (!onlyQuestions) {
            questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
          } else {
            questionnaireAnswers = [...questionnaireAnswers, ...group];
          }
        }
      })
    }
  }

  let childrenQuestionIds = [];
  for (const question of questionnaireAnswers) {
    if (question) {
      if (
        (
          question.idDomainQuestion === 270 ||
          question.idDomainQuestion === 271 ||
          (question.idDomainQuestion === 44 && typeof question.answer === 'object')
        ) && question.answer
      ) {
        if (!(question.idQuestion === 2143 && typeof question.answer === 'string')) {
          try {
            question.answer = JSON.stringify(question.answer)
          } catch (e) {
          }
        }
      }
    }
  }

  questionnaireAnswers = questionnaireAnswers.filter(qst => qst.idQuestion !== 2144 || qst.idQuestion !== 2145);
  return questionnaireAnswers;
}

function handleSubmit({
  values,
  questionnaire,
  onlyQuestions,
  SECTIONS,
  isDraft,
  refQuestionnaireSent,
  useSaveQuestionnaireAnswerRequest,
}) {

  if (refQuestionnaireSent.current) return;

  refQuestionnaireSent.current = true;

  const validQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    questionnaire,
    onlyQuestions,
    SECTIONS,
  });

  useSaveQuestionnaireAnswerRequest(validQuestionnaire);
}

function validationContactLength({
  clientsContacts,
  insurersContacts,
  insurers,
  isEndorsementWithoutPaymentPack,
  isDirectPaymentAnswer,
}) {
  if(isEndorsementWithoutPaymentPack && !clientsContacts.to.length) { 
    return {
      hasContact: false,
      message: "Add at least one 'to' contact for the client"
    }
  }

  if (!isDirectPaymentAnswer && !clientsContacts.to.length) {
    return {
      hasContact: false,
      message: "Add at least one 'to' contact for the client"
    }
  }
  
  if (!isEndorsementWithoutPaymentPack) {
    for (const insurer of insurers) {
      if(insurer.isLloyds || insurer.isLirma){
        continue;
      }
      
      const hasContact = insurersContacts.to.some((contact) => contact.idPersonInsurer === insurer.idPersonRoot);
      if (!hasContact) {
        return {
          hasContact: false,
          message: "Add at least one 'to' contact for the insurers"
        }
      }
    }
  }

  return {
    hasContact: true
  }
}

const events = {
  handleInitialAdjustments,
  handleSave,
};

export { events };